export default "assets/images/anacofi-19fa28c8.png";